import * as React from "react";
import { cn } from "@/lib/utils";
type InputProps = React.ComponentPropsWithoutRef<"input"> & {
  "data-testid"?: string;
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, id, "data-testid": dataTestId, ...props }, ref) => {
    return (
      <input
        ref={ref}
        id={id}
        data-testid={dataTestId}
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 placeholder-slate-400 shadow-sm transition-[border-color,box-shadow] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:border-blue-500 disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
